<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { Button } from '@kyoto2/components/ui/button'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  intent?: 'utility' | 'remove' | 'outline-trigger'
  size?: 'icon' | 'icon-sm' | 'icon-lg'
  ariaLabel: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  class?: HTMLAttributes['class']
}>(), {
  intent: 'utility',
  size: 'icon-sm',
  disabled: false,
  type: 'button',
})

const variant = computed(() =>
  props.intent === 'outline-trigger' ? 'outline' : 'ghost',
)

const intentClass = computed(() => {
  if (props.intent === 'remove') {
    return 'text-muted-foreground hover:text-destructive'
  }
  if (props.intent === 'utility') {
    return 'text-muted-foreground hover:text-foreground'
  }
  return undefined
})
</script>

<template>
  <Button
    :variant="variant"
    :size="size"
    :type="type"
    :disabled="disabled"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    :class="cn(intentClass, props.class)"
  >
    <slot />
  </Button>
</template>
